export default __webpack_public_path__ + "media/sach-foundation.e63fc79d.png";